import { render, staticRenderFns } from "./APP.vue?vue&type=template&id=1b394ef0&"
import script from "./APP.vue?vue&type=script&lang=js&"
export * from "./APP.vue?vue&type=script&lang=js&"
import style0 from "./APP.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports